import PropTypes from "prop-types";
import React, { Component } from "react";
import { Trans } from "@lingui/macro";
import { showBtnNext } from "../../actions";
import { connect } from "react-redux";

class Simple extends Component {
  componentDidMount() {
    this.props.step.data.fetchSource &&
      this.props.fetchData(this.props.step.data.fetchSource);
    this.props.showBtnNext(true);
  }

  getData = () => {
    const dataKey = this.props.step.data.keyValue;
    if (this.props.dataSource && this.props.dataSource[dataKey]) {
      let data = this.props.dataSource[dataKey];
      return data;
    }
    return null;
  };

  handleClick = () => {
    this.props.isValid(true);
  };

  render() {
    const { step } = this.props;
    return (
      <div>
        <span className="label">
          {step.icon && <img src={step.icon} alt={step.label} />}
          {step.label}
        </span>
        <div
          dangerouslySetInnerHTML={{
            __html: this.getData()
          }}
        />
        <div className="bottom">
          <button onClick={this.handleClick} className="custom-btn">
            <Trans id="W_STEP_BOUTON_CONTINUER" />
          </button>
        </div>
      </div>
    );
  }
}

Simple.propTypes = {
  dataSource: PropTypes.any,
  fetchData: PropTypes.func,
  isValid: PropTypes.func,
  showBtnNext: PropTypes.func,
  step: PropTypes.shape({
    data: PropTypes.shape({
      fetchSource: PropTypes.func,
      keyValue: PropTypes.any
    }),
    icon: PropTypes.any,
    label: PropTypes.any
  })
};

const mapStateToProps = state => {
  return {
    dataSource: state.dataSource
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchData: functionName => dispatch(functionName()),
    showBtnNext: isShow => dispatch(showBtnNext(isShow))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Simple);
